import React from "react";
// import { Switch, Redirect, Router, Route } from "wouter";

import { EnvContext } from "./context/env-context";

import PageStart from "./views/PageStart";

function App(props) {
  return (
    <EnvContext.Provider value={props.env}>
      <div className="tw-bg-white tw-relative tw-antialiased tw-font-text">
        {/* <Router base="/home">
                    <Switch>
                    <Route path="/" component={PageStart} />
                    </Switch>
                </Router> */}
        <PageStart />
      </div>
    </EnvContext.Provider>
  );
}

export default App;
